import StateMachine from '@/class/stateMachine'
import { Component, Vue } from 'vue-property-decorator'

// tools
import { fixedRound } from '@/utils/index'
import { refreshToken } from '@/utils/tokenExpire'
import { fillData } from '../utils/index'

// apis
import { getCrashData } from '@/api/dashboard'

@Component({
  name: 'CrashCaseTimeMixin'
})
export default class extends Vue {
  crashCauseTimeLastUpdate: string = '--'; // 故障导致限扭时长最新更新时间
  crashCauseTimeCycle: string = '--'; // 故障导致限扭时长最新更新频率
  crashCauseTimeTableData: Array<{ [key: string]: any }> = []; // 故障导致限扭时长 tableData
  get realCrashCauseTimeTableData() {
    return this.crashCauseTimeTableData.filter(data => !data.hidden)
  }

  crashCauseTimeMaxValue: number = 0 // 故障导致限扭时长最大值
  crashCauseProcessBarBG = ['#D9001B', '#F59A23', '#02A7F0', '#FACD91', '#C280FF', '#027DB4', '#C280FF', '#015478', '#6D000E', '#F59A23']
  crashCauseTimeStateMachine: StateMachine = new StateMachine();
  get computeCrashTimePercentage() {
    return (derateTime) => {
      if (derateTime > 0 && this.crashCauseTimeMaxValue > 0) return `${+fixedRound(derateTime / this.crashCauseTimeMaxValue * 100)}%`
      else return 0
    }
  }

  mileStateMachine: StateMachine = new StateMachine();
  mileLastUpdate: string = '--'; // mile 最新更新时间
  mileLastCycle: string = '--'; // mile 更新时间频率
  get mileChartConfig() {
    return orgData => {
      return Object.freeze({
        tooltip: {
          formatter: function(params) {
            // @ts-ignore
            return `区间：${params.name} <br> 次数：${fixedRound(+params.value, 0)} <br>`
          }
        },
        xAxis: {
          data: orgData.lx.map(data => `${data} KM`)
        },
        series: [
          {
            data: orgData.ly,
            type: 'bar',
            itemStyle: {
              color: '#017db4'
            }
          }
        ]
      })
    }
  }

  async getCrashData(selectors) {
    this.crashCauseTimeStateMachine.changeState('reload')
    this.mileStateMachine.changeState('reload')
    try {
      const { data } = await getCrashData({
        headers: {
          oem: encodeURIComponent(selectors.oem.join(',')),
          platform: encodeURIComponent(selectors.platform.join(',')),
          userGroup: encodeURIComponent(selectors.userGroup.join(','))
        }
      })
      // const data = { lastTime: '2021-05-13 17:23:51', data: [{ derateTime: 2460.45, esn: null, telFaultCode: '5655', map: { lastTime: '2021-05-13 17:23:51', data: { lx: ['0', '0-500', '500-3000', '3000-10000', '10000-30000', '30000-50000', '50000-100000', '100000-200000', '200000-300000', '300000-500000', '500000-1200000', '>1200000'], ly: ['1.0', '0.0', '599.0', '596.0', '733.0', '599.0', '986.0', '492.0', '43.0', '0.0', '0.0', '0.0'] }, pl: '1周1次' } }, { derateTime: 1525.65, esn: null, telFaultCode: '3867', map: { lastTime: '2021-05-13 17:23:51', data: { lx: ['0', '0-500', '500-3000', '3000-10000', '10000-30000', '30000-50000', '50000-100000', '100000-200000', '200000-300000', '300000-500000', '500000-1200000', '>1200000'], ly: ['0.0', '0.0', '816.0', '216.0', '151.0', '81.0', '114.0', '83.0', '14.0', '2.0', '0.0', '0.0'] }, pl: '1周1次' } }, { derateTime: 704.5, esn: null, telFaultCode: '5278', map: { lastTime: '2021-05-13 17:23:51', data: { lx: ['0', '0-500', '500-3000', '3000-10000', '10000-30000', '30000-50000', '50000-100000', '100000-200000', '200000-300000', '300000-500000', '500000-1200000', '>1200000'], ly: ['554.0', '0.0', '90.0', '67.0', '305.0', '281.0', '476.0', '211.0', '33.0', '0.0', '0.0', '0.0'] }, pl: '1周1次' } }, { derateTime: 315.1, esn: null, telFaultCode: '1673', map: { lastTime: '2021-05-13 17:23:51', data: { lx: ['0', '0-500', '500-3000', '3000-10000', '10000-30000', '30000-50000', '50000-100000', '100000-200000', '200000-300000', '300000-500000', '500000-1200000', '>1200000'], ly: ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0', '0.0', '0.0', '0.0', '0.0', '0.0', '0.0'] }, pl: '1周1次' } }, { derateTime: 199.1, esn: null, telFaultCode: '4277', map: { lastTime: '2021-05-13 17:23:51', data: { lx: ['0', '0-500', '500-3000', '3000-10000', '10000-30000', '30000-50000', '50000-100000', '100000-200000', '200000-300000', '300000-500000', '500000-1200000', '>1200000'], ly: ['2.0', '0.0', '382.0', '165.0', '211.0', '76.0', '89.0', '27.0', '1.0', '0.0', '0.0', '0.0'] }, pl: '1周1次' } }, { derateTime: 159.6, esn: null, telFaultCode: '6266', map: { lastTime: '2021-05-13 17:23:51', data: { lx: ['0', '0-500', '500-3000', '3000-10000', '10000-30000', '30000-50000', '50000-100000', '100000-200000', '200000-300000', '300000-500000', '500000-1200000', '>1200000'], ly: ['0.0', '0.0', '29.0', '41.0', '28.0', '13.0', '5.0', '1.0', '0.0', '0.0', '0.0', '0.0'] }, pl: '1周1次' } }, { derateTime: 98.65, esn: null, telFaultCode: '3242', map: { lastTime: '2021-05-13 17:23:51', data: { lx: ['0', '0-500', '500-3000', '3000-10000', '10000-30000', '30000-50000', '50000-100000', '100000-200000', '200000-300000', '300000-500000', '500000-1200000', '>1200000'], ly: ['0.0', '0.0', '2.0', '0.0', '14.0', '33.0', '40.0', '13.0', '1.0', '0.0', '0.0', '0.0'] }, pl: '1周1次' } }, { derateTime: 43.45, esn: null, telFaultCode: '6786', map: { lastTime: '2021-05-13 17:23:51', data: { lx: ['0', '0-500', '500-3000', '3000-10000', '10000-30000', '30000-50000', '50000-100000', '100000-200000', '200000-300000', '300000-500000', '500000-1200000', '>1200000'], ly: ['0.0', '0.0', '10.0', '35.0', '33.0', '18.0', '37.0', '18.0', '0.0', '0.0', '0.0', '0.0'] }, pl: '1周1次' } }, { derateTime: 42.3, esn: null, telFaultCode: '3725', map: { lastTime: '2021-05-13 17:23:51', data: { lx: ['0', '0-500', '500-3000', '3000-10000', '10000-30000', '30000-50000', '50000-100000', '100000-200000', '200000-300000', '300000-500000', '500000-1200000', '>1200000'], ly: ['0.0', '0.0', '1.0', '3.0', '3.0', '11.0', '23.0', '38.0', '2.0', '1.0', '0.0', '0.0'] }, pl: '1周1次' } }, { derateTime: 36.8, esn: null, telFaultCode: '3151', map: { lastTime: '2021-05-13 17:23:51', data: { lx: ['0', '0-500', '500-3000', '3000-10000', '10000-30000', '30000-50000', '50000-100000', '100000-200000', '200000-300000', '300000-500000', '500000-1200000', '>1200000'], ly: ['0.0', '0.0', '70.0', '53.0', '64.0', '80.0', '123.0', '54.0', '0.0', '0.0', '0.0', '0.0'] }, pl: '1周1次' } }], maxValue: '2460.45', pl: '1周1次' }
      // this.crashCauseTimeTableData = data.data
      this.crashCauseTimeLastUpdate = data.lastTime
      this.crashCauseTimeCycle = data.pl
      this.crashCauseTimeMaxValue = +data.maxValue
      this.crashCauseTimeStateMachine.changeState('resolve')
      this.mileStateMachine.changeState('resolve')

      this.$nextTick(() => {
        this.updateCrashTableData(data.data)
      })
    } catch (error) {
      if (error.message === '401:expired') {
        await refreshToken()
        location.reload()
      }

      if (error.message !== '402:abort') {
        this.crashCauseTimeStateMachine.changeState('reject')
        this.mileStateMachine.changeState('reject')
      }
    }
  }

  updateCrashTableData(data) {
    this.crashCauseTimeTableData = data
    if (data.length) fillData(this.crashCauseTimeTableData)
  }

  crashCauseTimeTableRowClass({ row }) {
    const classList: Array<string> = []
    if (row.hidden) classList.push('hide')

    return classList.join(' ')
  }
}
